import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { BusyButton } from '@ztechapps/webui.button'
import { useChannelContext } from './Context'
import styles from './ComposerToolbarEnd.module.scss'

export const ChannelSendButton = () => {
  const { onSend, status, message } = useChannelContext()
  const disabled = status?.busy || isEmpty(message)

  const onClickSendMessage = async () => {
    await onSend({ isPublic: true, format: 'html' })
  }

  return (
    // A spinner replaces the "Send" label rather than growing it into "Sending..." — the same
    // busyText=" " pattern FormalizeButton uses (libs/webui/data-tools/src/
    // FormalizeCommunication/FormalizeButton.tsx) — so the fixed width in the stylesheet has a
    // stable idle vs. busy content to hold, not a longer busy string to grow past it.
    <BusyButton
      variant="primary"
      icon="paper-plane"
      text="Send"
      busyText=" "
      isBusy={status?.sending}
      disabled={disabled}
      onClick={onClickSendMessage}
      className={styles.sendButton}
    />
  )
}
